import { useContext, useCallback } from 'react';
import { Localization } from '../../../model/store/providers/Localization';
import './Section.scss';
import './MfaSection.scss';
import { useAuth0 } from '@auth0/auth0-react';
import { auth0Domain, mfaScopes, rawTenantDomain, redirectUri } from '../../../config';
import axios from 'axios';
import { MfaFactors } from '../../../model/store/providers/MfaFactors';

export type Props = {
	title: string;
}

export const MfaSection = () => {
	const { translations } = useContext(Localization.State);
	const {
		mainPage: {
			mfaSection: {
				title,
			}
		}
	} = translations;

	return <>
		<h1 className='section__title'>{title}</h1>
		<div className='section__body'>
			<PhoneFactor />
		</div>
	</>;
}

function PhoneFactor() {
	const { translations } = useContext(Localization.State);
	const { getAccessTokenSilently, logout } = useAuth0();
	const { phoneFactor } = useContext(MfaFactors.State);
	const {
		mainPage: {
			mfaSection: {
				phone: {
					label,
					changeBtn
				}
			}
		}
	} = translations;

	const changePhoneNumber = useCallback(() => void async function() {
		if (!phoneFactor) return;

		const token = await getAccessTokenSilently({
			scope: mfaScopes,
			audience: `https://${rawTenantDomain}/mfa/`
		});

		await axios.delete(`https://${auth0Domain}/mfa/authenticators/${phoneFactor.id}`, {
			headers: {
				authorization: `Bearer ${token}`
			}
		});

		const withoutTrailingSlash = redirectUri.replace(/\/+$/, '');

		logout({ returnTo: `${withoutTrailingSlash}/login` });
	}(), [getAccessTokenSilently, phoneFactor, logout]);

	if (!phoneFactor) return null;

	return (
		<div className='section__item'>
			<div className='mfa-section__left'>
				<div className=''>
					<span>{label}</span> <span className='mfa-section__phone'>
						{phoneFactor.value}
					</span>
				</div>
			</div>
			<span className='wedge' />
			<div className='mfa-section__right'>
				<span className='section__secondary-link' onClick={changePhoneNumber}>{changeBtn}</span>
			</div>
		</div>
	);
}